<div class="row mb-2">
  <div class="col-xl-12">
    <ngb-accordion #acc="ngbAccordion" activeIds="filter-panel">
      <ngb-panel id="filter-panel" title="Filters">
        <ng-template ngbPanelContent>
          <div class="row">
            <div class="col-md-2">
              <label class="col-form-label" for="fixed-create-date-from">Create Date From</label>
              <input type="date" class="form-control" id="fixed-create-date-from"
                [(ngModel)]="fixedFilters.createDateFrom" />
            </div>
            <div class="col-md-2">
              <label class="col-form-label" for="fixed-create-date-to">Create Date To</label>
              <input type="date" class="form-control" id="fixed-create-date-to"
                [(ngModel)]="fixedFilters.createDateTo" />
            </div>
            <div class="col-md-2">
              <label class="col-form-label" for="fixed-status">Status</label>
              <ng-select id="fixed-status" placeholder="Select Status" [(ngModel)]="fixedFilters.status">
                <ng-option *ngFor="let option of statusOptions" [value]="option.value">{{ option.label }}</ng-option>
              </ng-select>
            </div>
            <div class="col-md-2">
              <label class="col-form-label" for="fixed-product">Product</label>
              <ng-select id="fixed-product" placeholder="Select Product" [(ngModel)]="fixedFilters.productCode18n">
                <ng-option *ngFor="let option of productCodeOptions" [value]="option.value">{{ option.label }}</ng-option>
              </ng-select>
            </div>
            <div class="col-md-2">
              <label class="col-form-label" for="fixed-sender-type">Sender Type</label>
              <ng-select id="fixed-sender-type" placeholder="Select Sender Type" [(ngModel)]="fixedFilters.senderType">
                <ng-option *ngFor="let option of partyTypeOptions" [value]="option.value">{{ option.label }}</ng-option>
              </ng-select>
            </div>
            <div class="col-md-2">
              <label class="col-form-label" for="fixed-receiver-type">Receiver Type</label>
              <ng-select id="fixed-receiver-type" placeholder="Select Receiver Type"
                [(ngModel)]="fixedFilters.receiverType">
                <ng-option *ngFor="let option of partyTypeOptions" [value]="option.value">{{ option.label }}</ng-option>
              </ng-select>
            </div>
          </div>
          <hr />
          <div *ngFor="let criterion of criteria; let i = index" class="row mt-4">
            <div class="col-md-4">
              <label class="col-form-label" [for]="'filter-field-' + i">Column Name</label>
              <ng-select [id]="'filter-field-' + i" placeholder="Select Column Name"
                [(ngModel)]="criterion.field" (ngModelChange)="onFieldChange(i)">
                <ng-option *ngFor="let field of fields" [value]="field.value">{{ field.label }}</ng-option>
              </ng-select>
            </div>

            <div class="col-md-4">
              <label class="col-form-label" [for]="'filter-operator-' + i">Operator</label>
              <ng-select [id]="'filter-operator-' + i" placeholder="Select Operator"
                [(ngModel)]="criterion.operator" (ngModelChange)="onOperatorChange(i)">
                <ng-option *ngFor="let operator of operators" [value]="operator.value">
                  {{ operator.label }}
                </ng-option>
              </ng-select>
            </div>

            <div class="col-md-3">
              <label class="col-form-label" [for]="'filter-value-' + i">Search Value</label>

              <ng-container *ngIf="isInOperator(criterion.operator); else singleValueMode">
                <ng-container *ngIf="getOptionsForField(criterion.field) as fieldOptions; else freeTextTags">
                  <ng-select [id]="'filter-value-' + i" [multiple]="true" [closeOnSelect]="false"
                    placeholder="Select values..." [(ngModel)]="criterion.valueList">
                    <ng-option *ngFor="let option of fieldOptions" [value]="option.value">
                      {{ option.label }}
                    </ng-option>
                  </ng-select>
                </ng-container>
                <ng-template #freeTextTags>
                  <ng-select [id]="'filter-value-' + i" [multiple]="true" [addTag]="true" [hideSelected]="true"
                    bindLabel="label" bindValue="label" [addTagText]="'Add value:'"
                    placeholder="Type a value and press Enter..." [(ngModel)]="criterion.valueList">
                  </ng-select>
                </ng-template>
              </ng-container>

              <ng-template #singleValueMode>
                <ng-container *ngIf="criterion.field === 'status'; else nonStatusValue">
                  <ng-select [id]="'filter-value-' + i" placeholder="Select Transaction Status"
                    [(ngModel)]="criterion.value">
                    <ng-option *ngFor="let option of statusOptions" [value]="option.value">
                      {{ option.label }}
                    </ng-option>
                  </ng-select>
                </ng-container>

                <ng-template #nonStatusValue>
                  <ng-container *ngIf="criterion.field === 'currency'; else nonCurrencyValue">
                    <ng-select [id]="'filter-value-' + i" placeholder="Select Currency"
                      [(ngModel)]="criterion.value">
                      <ng-option *ngFor="let option of currencyOptions" [value]="option.value">
                        {{ option.label }}
                      </ng-option>
                    </ng-select>
                  </ng-container>
                </ng-template>

                <ng-template #nonCurrencyValue>
                  <ng-container *ngIf="criterion.field === 'transactionType'; else nonTransactionTypeValue">
                    <ng-select [id]="'filter-value-' + i" placeholder="Select Credit/Debit"
                      [(ngModel)]="criterion.value">
                      <ng-option *ngFor="let option of txTypeOptions" [value]="option.value">
                        {{ option.label }}
                      </ng-option>
                    </ng-select>
                  </ng-container>
                </ng-template>

                <ng-template #nonTransactionTypeValue>
                  <ng-container *ngIf="criterion.field === 'onUs'; else nonOnUsValue">
                    <ng-select [id]="'filter-value-' + i" placeholder="Select On Us"
                      [(ngModel)]="criterion.value">
                      <ng-option *ngFor="let option of onUsOptions" [value]="option.value">
                        {{ option.label }}
                      </ng-option>
                    </ng-select>
                  </ng-container>
                </ng-template>

                <ng-template #nonOnUsValue>
                  <ng-container
                    *ngIf="criterion.field === 'senderType' || criterion.field === 'receiverType'; else nonPartyTypeValue">
                    <ng-select [id]="'filter-value-' + i" placeholder="Select Type" [(ngModel)]="criterion.value">
                      <ng-option *ngFor="let option of partyTypeOptions" [value]="option.value">
                        {{ option.label }}
                      </ng-option>
                    </ng-select>
                  </ng-container>
                </ng-template>

                <ng-template #nonPartyTypeValue>
                  <ng-container *ngIf="criterion.field === 'productCode18n'; else typedValue">
                    <ng-select [id]="'filter-value-' + i" placeholder="Select Transaction Type"
                      [(ngModel)]="criterion.value">
                      <ng-option *ngFor="let option of productCodeOptions" [value]="option.value">
                        {{ option.label }}
                      </ng-option>
                    </ng-select>
                  </ng-container>
                </ng-template>

                <ng-template #typedValue>
                  <div *ngIf="criterion.operator === 'between'; else singleValue" class="d-flex gap-2">
                    <input class="form-control" [id]="'filter-value-' + i"
                      [type]="criterion.field === 'createDate' ? 'datetime-local' : criterion.field === 'amount' ? 'number' : 'text'"
                      [(ngModel)]="criterion.value" placeholder="Start value" />
                    <input class="form-control"
                      [type]="criterion.field === 'createDate' ? 'datetime-local' : criterion.field === 'amount' ? 'number' : 'text'"
                      [(ngModel)]="criterion.valueEnd" placeholder="End value" />
                  </div>
                  <ng-template #singleValue>
                    <input class="form-control" [id]="'filter-value-' + i"
                      [type]="criterion.field === 'createDate' ? 'datetime-local' : criterion.field === 'amount' ? 'number' : 'text'"
                      [(ngModel)]="criterion.value" [placeholder]="getPlaceholder(criterion)" />
                  </ng-template>
                </ng-template>
              </ng-template>
            </div>

            <div class="col-md-1 d-flex align-items-end">
              <button type="button" class="btn bg-danger-custom w-100" (click)="removeCriterion(i)"
                title="Remove filter">
                <i class="feather icon-trash-2 me-1"></i>
              </button>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-md-12 text-end">
              <button type="button" class="btn bg-danger-custom" (click)="addCriterion()">
                <i class="feather icon-plus me-2"></i>Add Filter
              </button>
              <button type="button" class="btn bg-danger-custom" (click)="onSearch()">
                <i class="feather icon-search me-2"></i>Search
              </button>
              <button type="button" class="btn bg-secondary" (click)="onReset()">
                <i class="feather icon-refresh-cw me-2"></i>Reset
              </button>
            </div>
          </div>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>
</div>
